import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwap = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.0039 2L15.2483 4.50269L6.00391 4.50269L6.00391 6.50269L15.2483 6.50269L13.0039 9L14.5039 10.5L19.0039 5.50269L14.5039 0.500001L13.0039 2Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.00391 18L4.7595 15.4973L14.0039 15.4973L14.0039 13.4973L4.7595 13.4973L7.00391 11L5.50391 9.5L1.00391 14.4973L5.50391 19.5L7.00391 18Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgSwap);
export { ForwardRef as ReactComponent };
